import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#7E5C00',
        secondary: '#ebe6df',
        accent: '#F8F3EB',
        error: '#F0EADF',
      },
    },
  },
});
